import { useEffect } from "react";
import { Box, Grid, Typography, Divider } from "@mui/material";
import { useAppDispatch, useAppSelector } from "@/store";
import { fetchLatestArticles } from "@/store/articlesSlice";
import { LoadingScreen } from "@/components/LoadingScreen";
import { EmptyState } from "@/components/EmptyState";
import { documentTitleHome } from "@/constants/app";
import { hr } from "@/constants/strings.hr";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { HeroArticle } from "./HeroArticle";
import { InFocusPanel } from "./InFocusPanel";
import { ArticleCard } from "./ArticleCard";

export function HomePage() {
  const dispatch = useAppDispatch();
  const { latest, loading } = useAppSelector((s) => s.articles);

  useDocumentTitle(documentTitleHome());

  useEffect(() => {
    dispatch(fetchLatestArticles(20));
  }, [dispatch]);

  if (loading && latest.length === 0) return <LoadingScreen />;

  if (latest.length === 0) {
    return (
      <EmptyState
        title={hr.home.noArticlesTitle}
        description={hr.home.noArticlesBody}
      />
    );
  }

  const hero = latest[0];
  const focus = latest[1];
  const grid = latest.slice(focus ? 2 : 1);

  return (
    <Box>
      <Typography
        variant="overline"
        sx={{
          color: "secondary.main",
          fontWeight: 700,
          letterSpacing: "0.1em",
        }}
      >
        {hr.home.latestOverline}
      </Typography>
      <Divider sx={{ mb: 3, mt: 0.5 }} />
      <Grid container spacing={4} sx={{ mb: 4 }}>
        <Grid size={{ xs: 12, md: focus ? 8 : 12 }}>
          <HeroArticle article={hero} />
        </Grid>
        {focus && (
          <Grid size={{ xs: 12, md: 4 }}>
            <InFocusPanel article={focus} />
          </Grid>
        )}
      </Grid>
      {grid.length > 0 && (
        <>
          <Divider sx={{ mb: 3 }} />
          <Grid container spacing={3}>
            {grid.map((article) => (
              <Grid key={article.id} size={{ xs: 12, sm: 6, md: 4 }}>
                <ArticleCard article={article} />
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </Box>
  );
}
